import { Component, OnInit, output, input, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { PlannerService, Task, User } from '../../../core/services/planner.service';
import { TranslocoPipe } from '@jsverse/transloco';

interface TodoList {
  id: string;
  title: string;
  completed: boolean;
}

@Component({
  selector: 'app-planner-task-form',
  standalone: true,
  imports: [CommonModule, FormsModule, TranslocoPipe],
  templateUrl: './planner-task-form.component.html',
  styleUrls: ['./planner-task-form.component.scss'],
})
export class PlannerTaskFormComponent implements OnInit {
  selectedList = input<any>(null);
  taskSubmitted = output<Task>();
  formClosed = output<void>();

  task: Task = {
    title: '',
    description: '',
    status: 'pending',
    priority: 'medium',
    tags: [],
    comments: [],
    attachments: [],
    todo_lists: [],
  };

  newTag: string = '';
  newComment: string = '';
  availableAssignees: User[] = [];

  private plannerService = inject(PlannerService);

  constructor() {}

  ngOnInit() {
    this.availableAssignees = this.plannerService.getAvailableAssignees();
  }

  handleSubmit(): void {
    if (this.task.title && this.task.title.trim()) {
      this.taskSubmitted.emit(this.task);
      this.resetForm();
    }
  }

  resetForm(): void {
    this.task = {
      title: '',
      description: '',
      status: 'pending',
      priority: 'medium',
      tags: [],
      comments: [],
      attachments: [],
      todo_lists: [],
    };
    this.newTag = '';
    this.newComment = '';
  }

  closeForm(): void {
    this.formClosed.emit();
  }

  addTag(): void {
    if (this.newTag.trim() && !this.task.tags?.includes(this.newTag.trim())) {
      this.task.tags = [...(this.task.tags || []), this.newTag.trim()];
      this.newTag = '';
    }
  }

  removeTag(tagToRemove: string): void {
    this.task.tags = this.task.tags?.filter((tag) => tag !== tagToRemove);
  }

  addComment(): void {
    if (this.newComment.trim()) {
      this.task.comments = [...(this.task.comments || []), this.newComment.trim()];
      this.newComment = '';
    }
  }

  onKeyPress(event: KeyboardEvent, action: () => void): void {
    if (event.key === 'Enter') {
      event.preventDefault();
      action();
    }
  }
}
